import { Box, Button, Grid, Typography } from "@mui/material";
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "../../components/Header";
import OtherCarts from "../../components/Checkout/OtherCarts";
import UserContext from "../../context/User";

/**
 * Every cart the customer has, so the cart button asks which one rather than
 * dropping them into whichever happened to be active. The header only routes
 * here when there IS a choice — with a single cart it still goes straight to
 * checkout, and opening a cart from a restaurant page is unchanged.
 */
function Carts() {
  const navigate = useNavigate();
  const { cart, restaurant, otherCarts } = useContext(UserContext);

  const MUTED = "#6B7280";
  const INK = "#111827";
  const ACCENT = "#FF3008";

  const hasActive = Boolean(restaurant) && cart?.length > 0;

  return (
    <Grid container sx={{ backgroundColor: "#F5F5F5", minHeight: "100vh" }}>
      <Header />
      <Grid item xs={12} sx={{ mt: "64px", px: 2, py: 4, display: "flex", justifyContent: "center" }}>
        <Box sx={{ width: "100%", maxWidth: 720 }}>
          <Typography sx={{ fontSize: "1.5rem", fontWeight: 800, color: INK, mb: 2.5 }}>
            Your carts
          </Typography>

          <OtherCarts title={null} includeActive />

          {!hasActive && !otherCarts?.length && (
            <Box sx={{ textAlign: "center", py: 8 }}>
              <Typography sx={{ fontSize: "1rem", color: MUTED, mb: 0.5 }}>
                Your cart is empty
              </Typography>
              <Typography sx={{ fontSize: "0.875rem", color: "#9CA3AF", mb: 2 }}>
                Add items from a restaurant to get started
              </Typography>
              <Button
                onClick={() => navigate("/")}
                sx={{
                  textTransform: "none",
                  fontWeight: 800,
                  borderRadius: "12px",
                  px: 3,
                  py: 1,
                  color: "#fff",
                  backgroundColor: ACCENT,
                  "&:hover": { backgroundColor: "#D92600" },
                }}
              >
                Browse Restaurants
              </Button>
            </Box>
          )}
        </Box>
      </Grid>
    </Grid>
  );
}

export default Carts;
